import React from 'react';
import {
  Modal,
  Box,
  SpaceBetween,
  Button
} from '@cloudscape-design/components';

const CustomModal = ({
  visible,
  onDismiss,
  onConfirm,
  isProcessing,
  message
}) => {
  return (
    <Modal
      visible={visible}
      onDismiss={onDismiss}
      header="Notice"
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
            <Button
              variant="link"
              onClick={onDismiss}
              disabled={isProcessing}
            >
              Close
            </Button>
          </SpaceBetween>
        </Box>
      }
    >
      <p>
        {message}
      </p>
    </Modal>
  );
};

export default CustomModal;